import React from 'react';

import { Alert, AlertDescription } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import { REBRANDING_GUIDE_URL } from 'app/developer-v3/constants';
import { useRouter, useActiveProfile } from 'app/developer-v3/hooks';

type Props = {
  title: string;
};

const CtaPublicIntegration = ({ title }: Props) => {
  const { params } = useRouter();
  const { activeProfile } = useActiveProfile();
  const url = new URL(REBRANDING_GUIDE_URL);
  url.searchParams.set('app_id', params.id);
  url.searchParams.set('email', activeProfile.email);
  url.searchParams.set('title', title);

  return (
    <Alert
      status="warning"
      title="You can’t edit settings for this integration."
    >
      <AlertDescription>
        To edit your integration details on Zapier's public app directory,
        please submit{' '}
        <Link href={url.href} target="_blank">
          this form
        </Link>
        .
      </AlertDescription>
    </Alert>
  );
};

export default CtaPublicIntegration;
